/* eslint-env browser */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CashoutOnboardingForm from '../forms/CashoutOnboardingForm';

export default function CashoutOnboardingModalContent({
  payAccount,
  onPaymentMethodUpdate,
  onClose,
}) {
  const { t } = useTranslation(null, { useSuspense: false });

  const [showForm, setShowForm] = useState(false);

  return (
    <>
      {!showForm && (
        <div
          id="cashout-tax-requirements"
          className="phoenix-simple-dialog-view modal fade member-diamonds-cash-confirm in show"
          aria-hidden="false"
        >
          <div className="modal-backdrop fade in" />
          <div className="modal-dialog">
            <div className="modal-content modal-content-sm">
              {/* eslint-disable-next-line */}
              <a
                className="close phoenix-icon phoenix-icon-cross"
                onClick={onClose}
              />
              <div className="modal-header">
                <h4>{t('index_cash_out')}</h4>
                <hr />
              </div>
              <div className="modal-body">
                <p>{t('cashout_fill_out_my_onboarding_form_description')}</p>
                <div className="cashout-requirement">
                  <button
                    type="button"
                    className="cashout-taxbandits-registration-button btn btn-block btn-blue"
                    onClick={() => setShowForm(true)}
                  >
                    {t('cashout_fill_out_my_onboarding_form')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showForm && (
        <CashoutOnboardingForm
          title=""
          payAccount={payAccount}
          onClose={() => {
            setShowForm(false);
            onPaymentMethodUpdate();
          }}
        />
      )}
    </>
  );
}
CashoutOnboardingModalContent.propTypes = {
  payAccount: PropTypes.shape({
    provider: PropTypes.string.isRequired,
  }).isRequired,
  onPaymentMethodUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
